import Overlay from 'ol/Overlay';
import React, { useEffect, useMemo, useState } from 'react';
import { useMap } from '@/state/context/MapContext';
import { unByKey } from 'ol/Observable';

export const enum HelpTooltipText {
    START = 'Trykk for å start en måling',
    CONTINUE = 'Dobbelklikk for å avslutte måling',

    START_POLYGON = 'Trykk for å start en tegning',
    END_POLYGON = 'Dobbelklikk for å avslutte polygon',
}
interface HelpTooltipProps {
    tip?: HelpTooltipText;
}
export const HelpTooltip = ({ tip }: HelpTooltipProps) => {
    const { map } = useMap();
    const [showHelp, setShowHelp] = useState(true);
    const overlay = useMemo(() => {
        const o = new Overlay({
            stopEvent: false,
            insertFirst: false,
            offset: [15, 0],
            positioning: 'center-left',
        });
        map.addOverlay(o);
        return o;
    }, [map]);

    useEffect(() => {
        const viewPort = map.getViewport();
        const showHelpEvent = () => setShowHelp(true);
        const hideHelpEvent = () => setShowHelp(false);
        viewPort?.addEventListener('mouseleave', hideHelpEvent);
        viewPort?.addEventListener('mouseenter', showHelpEvent);
        const pointerMoveKey = map.on('pointermove', evt => {
            if (evt.dragging) return;
            overlay.setPosition(evt.coordinate);
        });
        return () => {
            viewPort?.removeEventListener('mouseleave', hideHelpEvent);
            viewPort?.removeEventListener('mouseenter', showHelpEvent);
            unByKey(pointerMoveKey);
        };
    }, [map, overlay]);

    return (
        <div
            id={'measure-help-tooltip'}
            ref={r => overlay.setElement(r ?? undefined)}
            className={`c-map-tooltip ${showHelp ? '' : 't-hidden'}`}
        >
            {tip}
        </div>
    );
};
